import { HTTP_INTERCEPTORS, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

/**
 * Mock HTTP Interceptor that doesn't add authentication headers
 * Used in development mode when useMockAuth is true
 */
@Injectable()
export class MockHttpInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Just pass through without adding auth headers
    // The backend will use DevelopmentAuthenticationHandler
    console.log('🔓 Mock Auth: HTTP request (no token added)');
    return next.handle(req);
  }
}

/**
 * Provider for HTTP interceptor based on environment
 */
export function provideMockOrRealInterceptor() {
  if (environment.useMockAuth) {
    return {
      provide: HTTP_INTERCEPTORS,
      useClass: MockHttpInterceptor,
      multi: true
    };
  }
  // Real MSAL interceptor is configured in main.ts
  return [];
}
